// extracted by mini-css-extract-plugin
export default {"clientEmployees":"AdminClients_clientEmployees__x4Oay","activeRow":"AdminClients_activeRow__BnBFO"};